<script>
import {
  measureListComputed,
  measureListMethods,
} from '@state/helpers/measure-list'
import SearchPayload from '@utils/searchPayload'
import { ObjectHelper, csvExport, addParamsToLocation } from '@utils/helpers'
import CsvExportPopup from '@components/molecules/csv-export-popup.vue'
import { CSV_FILE_NAME } from '@utils/csvFilename'
import { COMMENT_LEVEL, DATE_TIME_FORMAT } from '@utils/constant'
import formatDate from '@utils/format-date'
import { endOfDay, startOfDay } from 'date-fns'
import cloneDeep from 'lodash/cloneDeep'
import {
  rateItem,
  COLOR_RATE,
  COLOR_RATE_MUS,
  COLOR_RATE_FAT,
} from '@utils/rateItem'
import fieldsTable from './list/fieldsTable'

export default {
  COLOR_RATE,
  COMMENT_LEVEL,
  COLOR_RATE_FAT,
  COLOR_RATE_MUS,
  components: { CsvExportPopup },
  data() {
    return {
      items: {},
      searchBody: new SearchPayload.Builder(),
      fields: fieldsTable,
      filtered: false,
      openConfirm: false,
      measureIdSelected: {},
      closeDeleteTitle: 'common.cancel',
      rateItem: rateItem,
      measureListData: [],
      csvKey: 0,
    }
  },
  computed: {
    ...measureListComputed,
    paginationComputed() {
      let paginations = {}
      if (this.getMeasureList) {
        paginations = ObjectHelper.removePropertyByKey('list')(
          this.getMeasureList
        )
      }
      return paginations
    },
  },
  watch: {
    searchBody() {
      addParamsToLocation(this.$route, this.searchBody)
    },
  },
  created() {
    const filter = this.$route.query
    filter.page_no = parseInt(filter.page_no, 10)
    filter.lines = parseInt(filter.lines, 10)
    for (const key in filter) {
      if (key !== 'page_no' && key !== 'lines') {
        if (filter[key] !== '' && filter[key] !== undefined) {
          this.searchBody = filter
          this.filtered = true
        }
      }
    }
    if (filter.page_no > 1) {
      this.searchBody = filter
    }
    this.handleSearchMeasure()
  },
  methods: {
    ...measureListMethods,
    handlePagination(body) {
      this.searchBody = { ...this.searchBody, ...body }
      this.handleSearchMeasure()
    },
    async handleSearchMeasure() {
      const params = {
        member_id: parseInt(this.$route.params.id),
        order_by: 'created_at-',
      }
      this.searchBody = { ...this.searchBody, ...params }
      const response = await this.fetchingMeasureList(this.searchBody)
      if (response && typeof response === 'object') {
        this.measureListData =
          cloneDeep(response)?.list.map((item) => {
            item.device_name = item.device_name ? item.device_name : '手動'
            item.athlete = item.athlete === 0 ? 'off' : 'on'
            item.weight = parseFloat(item.data.weight).toFixed(2) + 'kg'
            item.BMI = parseFloat(item.data.BMI).toFixed(1)
            item.body_fat_rate =
              parseFloat(item.data.body_fat_rate).toFixed(1) + '%'
            item.lean_body_weight =
              parseFloat(item.data.lean_body_weight).toFixed(2) + 'kg'
            item.subcutaneous_fat =
              parseFloat(item.data.subcutaneous_fat).toFixed(1) + '%'
            item.visceral_fat = parseFloat(item.data.visceral_fat).toFixed(0)
            item.body_water_rate =
              parseFloat(item.data.body_water_rate).toFixed(1) + '%'
            item.muscle_rate =
              parseFloat(item.data.muscle_rate).toFixed(1) + '%'
            item.muscle_mass =
              parseFloat(item.data.muscle_mass).toFixed(2) + 'kg'
            item.protein = parseFloat(item.data.protein).toFixed(2) + '%'
            item.BMR = parseFloat(item.data.BMR).toFixed(0) + 'kcal'
            item.metabolic_age = parseFloat(item.data.metabolic_age).toFixed(0)
            item.bone_mass = parseFloat(item.data.bone_mass).toFixed(2) + 'kg'
            return item
          }) || []
      }
    },

    async exportCsv(date) {
      date.date_end = formatDate(
        endOfDay(new Date(date.date_end)),
        DATE_TIME_FORMAT
      )
      date.date_start = formatDate(
        startOfDay(new Date(date.date_start)),
        DATE_TIME_FORMAT
      )
      const response = await this.exportMeasureCsv({
        ...this.searchBody,
        ...date,
      })

      csvExport(response, CSV_FILE_NAME.measureList)
      this.csvKey++
    },
  },
}
</script>

<template>
  <div>
    <BasePagination
      :paginations="paginationComputed"
      :searching="filtered"
      @activePagination="handlePagination"
    >
      <template v-slot:secondary>
        <CsvExportPopup :key="csvKey" @export="exportCsv" />
      </template>
    </BasePagination>
    <BaseTable
      striped
      hover
      border
      :table-fields="fields"
      :data-tables="measureListData"
    >
      <template v-for="rate in rateItem" v-slot:[rate.key]="{ item }">
        <td :key="rate.key">
          <div>
            <CBadge
              :class="
                $options[rate.color][item.data[rate.label]] &&
                  $options[rate.color][item.data[rate.label]]
              "
            >
              {{ $options.COMMENT_LEVEL[item.data[rate.label]] }}
            </CBadge>
          </div>
          {{ item[rate.key] }}
        </td>
      </template>
    </BaseTable>
  </div>
</template>
